export const products = [
  {
    id: 1,
    name: "Floral Summer Dress",
    price: 1299,
    category: "dresses",
    gender: "girls",
    age: "2-4 Years",
    color: "pink",
    images: [
      "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1514090458221-65bb69cf63e6?w=600&h=800&fit=crop",
    ],
    sizes: ["2Y", "3Y", "4Y"],
    description:
      "Beautiful floral print dress perfect for summer days. Made with soft, breathable cotton fabric that keeps your little one comfortable all day long.",
    features: [
      "100% Cotton",
      "Machine Washable",
      "Breathable Fabric",
      "Comfortable Fit",
    ],
  },
  {
    id: 2,
    name: "Denim Jacket",
    price: 1799,
    category: "jackets",
    gender: "boys",
    age: "8-10 Years",
    color: "blue",
    images: [
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Classic denim jacket with a modern fit. Perfect for layering in any season. Durable construction ensures long-lasting wear.",
    features: [
      // "Premium Denim", "Durable", "Classic Fit", "Easy Care"
    ],
  },
  {
    id: 3,
    name: "Striped T-Shirt",
    price: 799,
    category: "tops",
    gender: "boys",
    age: "2-4 Years",
    color: "red",
    images: [
      "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1622290291468-a28f7a7dc6a8?w=600&h=800&fit=crop",
    ],
    sizes: ["2Y", "3Y", "4Y"],
    description:
      "Comfortable striped t-shirt made from 100% cotton. Perfect for everyday wear with a fun, playful design that kids love.",
    features: ["Soft Cotton", "Colorfast", "Comfortable", "Easy Maintenance"],
  },
  {
    id: 4,
    name: "Princess Party Dress",
    price: 2499,
    category: "dresses",
    gender: "girls",
    age: "8-10 Years",
    color: "purple",
    images: [
      "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1619139762322-48e0bf46e1f4?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Elegant party dress with beautiful detailing and premium fabric. Perfect for special occasions, birthdays, and celebrations.",
    features: [
      "Premium Fabric",
      "Elegant Design",
      "Special Occasion",
      "Hand Wash",
    ],
  },
  {
    id: 5,
    name: "Casual Shorts Set",
    price: 1199,
    category: "co-ord sets",
    gender: "boys",
    age: "2-4 Years",
    color: "green",
    images: [
      "https://images.unsplash.com/photo-1622290291468-a28f7a7dc6a8?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=800&fit=crop",
    ],
    sizes: ["2Y", "3Y", "4Y"],
    description:
      "Comfortable casual set perfect for playtime. Includes matching top and shorts made from breathable, easy-care fabric.",
    features: [
      "Matching Set",
      "Breathable",
      "Playtime Ready",
      "Machine Washable",
    ],
  },
  {
    id: 6,
    name: "Polka Dot Romper",
    price: 1099,
    category: "rompers",
    gender: "girls",
    age: "0-2 Years",
    color: "pink",
    images: [
      "https://images.unsplash.com/photo-1522771930-78848d9293e8?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1519457431-44ccd64a579b?w=600&h=800&fit=crop",
    ],
    sizes: ["6M", "12M", "18M", "24M"],
    description:
      "Adorable polka dot romper for little ones. Soft and comfortable for all-day wear with easy snap closures for quick changes.",
    features: [
      "Soft Fabric",
      "Easy Snap Closure",
      "Comfortable",
      "Cute Design",
    ],
  },
  {
    id: 7,
    name: "Sports Track Suit",
    price: 1899,
    category: "co-ord sets",
    gender: "boys",
    age: "8-10 Years",
    color: "black",
    images: [
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Athletic track suit perfect for sports and active play. Breathable, moisture-wicking fabric with durable construction.",
    features: [
      "Athletic Wear",
      "Moisture Wicking",
      "Durable",
      "Comfortable Fit",
    ],
  },
  {
    id: 8,
    name: "Cotton Baby Onesie",
    price: 599,
    category: "onesies",
    gender: "unisex",
    age: "0-2 Years",
    color: "white",
    images: [
      "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1519457431-44ccd64a579b?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1522771930-78848d9293e8?w=600&h=800&fit=crop",
    ],
    sizes: ["0-3M", "3-6M", "6-12M"],
    description:
      "Soft cotton onesie for newborns. Gentle on sensitive skin with easy snap closures. Perfect for everyday wear.",
    features: ["100% Cotton", "Gentle Fabric", "Easy Closure", "Newborn Safe"],
  },
  {
    id: 9,
    name: "Tutu Skirt",
    price: 899,
    category: "bottoms",
    gender: "girls",
    age: "2-4 Years",
    color: "pink",
    images: [
      "https://images.unsplash.com/photo-1619139762322-48e0bf46e1f4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&h=800&fit=crop",
    ],
    sizes: ["2Y", "3Y", "4Y"],
    description:
      "Playful tutu skirt perfect for dance and dress-up. Multiple layers for extra fluffiness. Elastic waistband for comfortable fit.",
    features: [
      "Multiple Layers",
      "Elastic Waist",
      "Playful Design",
      "Dance Ready",
    ],
  },
  {
    id: 10,
    name: "Formal Blazer",
    price: 2299,
    category: "jackets",
    gender: "boys",
    age: "8-10 Years",
    color: "navy",
    images: [
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Smart formal blazer for special occasions. Tailored fit with premium fabric. Perfect for weddings, parties, and formal events.",
    features: [
      "Premium Fabric",
      "Tailored Fit",
      "Formal Wear",
      "Special Occasions",
    ],
  },
  {
    id: 11,
    name: "Floral Leggings",
    price: 699,
    category: "bottoms",
    gender: "girls",
    age: "8-10 Years",
    color: "multicolor",
    images: [
      "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1619139762322-48e0bf46e1f4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Comfortable leggings with beautiful floral print. Stretchy and perfect for active play. Matches well with various tops.",
    features: ["Stretchy Fabric", "Floral Print", "Comfortable", "Versatile"],
  },
  {
    id: 12,
    name: "Graphic Tee",
    price: 799,
    category: "tops",
    gender: "boys",
    age: "8-10 Years",
    color: "yellow",
    images: [
      "https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1622290291468-a28f7a7dc6a8?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Cool graphic t-shirt with fun design. Made from soft, breathable cotton. Perfect for casual everyday wear.",
    features: ["Soft Cotton", "Cool Graphics", "Breathable", "Casual Wear"],
  },
  {
    id: 13,
    name: "Winter Hoodie",
    price: 1599,
    category: "hoodies",
    gender: "boys",
    age: "8-10 Years",
    color: "gray",
    images: [
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Warm and cozy winter hoodie. Perfect for cold weather with soft fleece lining.",
    features: ["Warm Fleece", "Comfortable", "Durable", "Winter Wear"],
  },
  {
    id: 14,
    name: "Knit Sweater",
    price: 1899,
    category: "sweaters",
    gender: "girls",
    age: "8-10 Years",
    color: "cream",
    images: [
      "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1619139762322-48e0bf46e1f4?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Beautiful knit sweater perfect for autumn-winter season. Soft and warm.",
    features: ["Soft Knit", "Warm", "Stylish", "Premium Quality"],
  },
  {
    id: 15,
    name: "Corduroy Pants",
    price: 1299,
    category: "bottoms",
    gender: "boys",
    age: "8-10 Years",
    color: "brown",
    images: [
      "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Classic corduroy pants with comfortable fit. Perfect for autumn-winter wear.",
    features: ["Corduroy Fabric", "Comfortable", "Durable", "Classic Style"],
  },
  {
    id: 16,
    name: "Quilted Vest",
    price: 1499,
    category: "jackets",
    gender: "girls",
    age: "8-10 Years",
    color: "navy",
    images: [
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&h=800&fit=crop",
      "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=600&h=800&fit=crop",
    ],
    sizes: ["8Y", "10Y", "12Y", "14Y"],
    description:
      "Lightweight quilted vest for layering. Perfect for transitional weather.",
    features: ["Quilted Design", "Lightweight", "Warm", "Easy Layering"],
  },
];

export const categories = {
  girls: {
    name: "Girls",
    shopByCategory: [
      { name: "Co-ord Sets", slug: "co-ord sets" },
      { name: "Dresses", slug: "dresses" },
      { name: "Sweaters & Cardigans", slug: "sweaters" },
      { name: "Jackets & Coats", slug: "jackets" },
      { name: "Sweatshirt & Hoodies", slug: "hoodies" },
      { name: "Tops & tees", slug: "tops" },
      { name: "Bottoms", slug: "bottoms" },
      { name: "Atheleisure", slug: "atheleisure" },
    ],
    shopByAge: [
      { name: "0-2 Years", slug: "0-2" },
      { name: "2-4 Years", slug: "2-4" },
      { name: "4-6 Years", slug: "4-6" },
      { name: "6-8 Years", slug: "6-8" },
      { name: "8-10 Years", slug: "8-10" },
      { name: "10-12 Years", slug: "10-12" },
      { name: "12-14 Years", slug: "12-14" },
      { name: "14 + Years", slug: "14+" },
    ],
    shopByCollection: [
      { name: "Festive 15", slug: "festive-15" },
      { name: "FALL EDIT", slug: "fall-edit" },
      { name: "SEASON OF STYLE", slug: "season-of-style" },
      { name: "Everyday Basics", slug: "everyday-basics" },
    ],
  },
  boys: {
    name: "Boys",
    shopByCategory: [
      { name: "Co-ord Sets", slug: "co-ord sets" },
      { name: "Sweaters & Cardigans", slug: "sweaters" },
      { name: "Jackets & Coats", slug: "jackets" },
      { name: "Sweatshirt & Hoodies", slug: "hoodies" },
      { name: "Tops & tees", slug: "tops" },
      { name: "Bottoms", slug: "bottoms" },
      { name: "Atheleisure", slug: "atheleisure" },
    ],
    shopByAge: [
      { name: "0-2 Years", slug: "0-2" },
      { name: "2-4 Years", slug: "2-4" },
      { name: "4-6 Years", slug: "4-6" },
      { name: "6-8 Years", slug: "6-8" },
      { name: "8-10 Years", slug: "8-10" },
      { name: "10-12 Years", slug: "10-12" },
      { name: "12-14 Years", slug: "12-14" },
      { name: "14 + Years", slug: "14+" },
    ],
    shopByCollection: [
      { name: "Festive 15", slug: "festive-15" },
      { name: "FALL EDIT", slug: "fall-edit" },
      { name: "SEASON OF STYLE", slug: "season-of-style" },
      { name: "Everyday Basics", slug: "everyday-basics" },
    ],
  },
};

export const heroSlides = [];
//  [
//   {
//     id: 1,
//     image:
//       "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=1400&h=600&fit=crop",
//     title: "New Autumn-Winter Collection",
//     subtitle: "Cozy styles for little ones",
//     buttonText: "Shop Now",
//   },
//   {
//     id: 2,
//     image:
//       "https://images.unsplash.com/photo-1514090458221-65bb69cf63e6?w=1400&h=600&fit=crop",
//     title: "Premium Kids Fashion",
//     subtitle: "Quality you can trust",
//     buttonText: "Explore",
//   },
//   {
//     id: 3,
//     image:
//       "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=1400&h=600&fit=crop",
//     title: "Everyday Basics",
//     subtitle: "Comfortable & Stylish",
//     buttonText: "Shop Collection",
//   },
// ];

export const shopByCategoryData = [
  {
    title: "Shop by Category",
    items: [
      "Co-ord Sets",
      "Dresses",
      "Sweaters & Cardigans",
      "Jackets & Coats",
      "Sweatshirt & Hoodies",
      "Tops & tees",
      "Bottoms",
      "Atheleisure",
    ],
  },
  {
    title: "Shop by Age",
    items: [
      "0-2 Years",
      "2-4 Years",
      "4-6 Years",
      "6-8 Years",
      "8-10 Years",
      "10-12 Years",
      "12-14 Years",
      "14 + Years",
    ],
  },
  {
    title: "Shop by Collection",
    items: ["Festive 15", "FALL EDIT", "SEASON OF STYLE", "Everyday Basics"],
  },
];
